import React from "react";
import { Link } from "react-router-dom";
import { MATERIALS, MATERIAL_COLORS } from "@/lib/apiClient";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import Seo from "./Seo";

const IMG = "https://images.unsplash.com/photo-1611284446314-60a58ac0deb9?w=1600&q=80&auto=format&fit=crop";

const DESCRIPTIONS = {
  "Gravats": "Béton, briques, parpaings, tuiles, carrelage. Matériaux inertes du BTP.",
  "Plâtre & placo": "Plaques de plâtre, BA13, faux plafonds. Filière dédiée.",
  "Mélange bitumineux": "Enrobés de chaussée, fraisat, croûtes d'asphalte issus des travaux routiers.",
  "Déchets verts": "Tontes, branches, feuilles, taille de haies. Compostage et valorisation.",
  "Souches & troncs": "Souches d'arbres, troncs et bois entiers issus de l'élagage et de l'abattage.",
  "Bois": "Palettes, panneaux, cagettes, bois de construction non traité.",
  "DIB": "Déchets industriels banals : cartons, plastiques, mousses, mélanges non dangereux.",
  "Archives": "Documents papier confidentiels. Destruction et certificat délivré.",
  "Pneus VL": "Pneumatiques véhicules légers usagés.",
  "Pneus PL": "Pneumatiques poids lourds et engins.",
};

export default function Matieres() {
  return (
    <div>
      <Seo
        title="Nos déchets acceptés — gravats, plâtre, déchets verts, bois, DIB"
        description="FB Environnement à Saint-Victoret accepte tous les déchets professionnels : gravats (jusqu'à 30 m³), déchets verts, bois & palettes, métaux, plâtre, DIB, archives et pneus VL/PL."
        path="/dechets"
      />
      {/* Hero */}
      <section className="relative">
        <div className="absolute inset-0">
          <img src={IMG} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0f3a18]/95 to-[#1F6B2E]/70" />
        </div>
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-20">
          <span className="inline-block bg-[#9DCB2E] text-[#0f3a18] font-black uppercase tracking-[0.15em] text-xs px-3 py-1.5 rounded-full">
            10 matières acceptées
          </span>
          <h1 className="font-heading font-black text-white text-4xl sm:text-5xl tracking-tight mt-5 max-w-3xl">
            Les déchets que nous prenons en charge
          </h1>
          <p className="text-stone-100 text-lg mt-4 max-w-2xl">
            Du gravat aux pneus en passant par les archives confidentielles : on traite, on trie, on valorise.
          </p>
        </div>
      </section>

      {/* Grille des matières */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {MATERIALS.map((m) => (
            <div
              key={m}
              data-testid={`matiere-${m}`}
              className="bg-white rounded-3xl border border-stone-100 p-5 hover:-translate-y-1 hover:shadow-xl transition-all"
            >
              <span className={`inline-block px-3 py-1.5 rounded-full text-sm font-black ${MATERIAL_COLORS[m]}`}>
                {m}
              </span>
              <p className="text-stone-600 text-sm mt-3 leading-relaxed">{DESCRIPTIONS[m]}</p>
              <div className="flex items-center gap-1.5 text-xs text-[#1F6B2E] font-bold mt-3">
                <CheckCircle2 className="w-4 h-4" strokeWidth={2.8} /> Tarif à la tonne ou à la benne
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-[#f6faf0] border-2 border-dashed border-[#9DCB2E] rounded-3xl p-6 sm:p-8 text-center">
          <h3 className="font-heading font-black text-2xl text-[#1F6B2E]">
            Un déchet qui n&apos;est pas dans la liste ?
          </h3>
          <p className="text-stone-600 mt-2 max-w-xl mx-auto">
            On gère probablement quand même. Pour plus d&apos;informations, contactez-nous.
          </p>
          <Link
            to="/contact"
            data-testid="matieres-cta"
            className="mt-5 inline-flex items-center gap-2 bg-[#1F6B2E] hover:bg-[#175522] text-white font-bold px-5 py-3 rounded-full transition-all active:scale-95"
          >
            Nous contacter <ArrowRight className="w-4 h-4" strokeWidth={3} />
          </Link>
        </div>
      </section>
    </div>
  );
}
